import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { PayoutRoutingModule } from './payout-routing.module'
import { SharedModule } from 'src/app/shared/shared.module'
import { SpPayoutComponent } from './pages/sp-payout/sp-payout-list.component'
import { SpPayoutTableComponent } from './components/sp-payout-table/sp-payout-table.component'
import { SpPayoutFilterComponent } from './components/sp-payout-filter/sp-payout-filter.component'
import { PayoutDetailsComponent } from './pages/payout-details/payout-details.component'
import { ClientPayoutListComponent } from './pages/client-payout-list/client-payout-list.component'
import { ClientPayoutTableComponent } from './components/client-payout-table/client-payout-table.component'
import { SpSelectTransactionComponent } from './components/sp-select-transaction/sp-select-transaction.component'
import { ClientPayoutFilterComponent } from './components/client-payout-filter/client-payout-filter.component'
import { AcceptRejectClientPayoutPopupComponent } from './components/accept-reject-client-payout-popup/accept-reject-client-payout-popup.component'
import { SpPayoutListComponent } from './components/sp-payout-list/sp-payout-list.component'
import { SpPayoutListFilterComponent } from './components/sp-payout-list-filter/sp-payout-list-filter.component'
import { SpPayoutDetailsComponent } from './components/sp-payout-details/sp-payout-details.component'

@NgModule({
	declarations: [
		SpPayoutComponent,
		SpPayoutTableComponent,
		SpPayoutFilterComponent,
		PayoutDetailsComponent,
		ClientPayoutListComponent,
		ClientPayoutTableComponent,
		SpSelectTransactionComponent,
		ClientPayoutFilterComponent,
		AcceptRejectClientPayoutPopupComponent,
		SpPayoutListComponent,
		SpPayoutListFilterComponent,
		SpPayoutDetailsComponent,
	],
	imports: [CommonModule, PayoutRoutingModule, SharedModule],
	exports: [
		PayoutDetailsComponent,
		SpPayoutListComponent,
		SpPayoutListFilterComponent,
	],
})
export class PayoutModule {}
